export const APP_NAME = "Calibrate";
export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000/";
export const PRIVACY_POLICY_URL = "https://calibratehcm.com/privacy-policy";
export const TERMS_OF_SERVICE_URL =
  "https://calibratehcm.com/terms-and-conditions";

export const LOGO_URL = "/images/logo.png";

export const CHCM_LOGO_MARK_WHITE_URL = "/branding/chcm-logo-mark-white.svg";

export const TOP_BAR_LOGO_HEIGHT_PX = 52;

export {
  SHELL_TOP_BAR_PX,
  SHELL_FOOTER_PX,
  SHELL_SIDEBAR_WIDTH_PX,
  SHELL_NAV_ROW_HEIGHT_PX,
  SHELL_NAV_GAP_PX,
  SHELL_NAV_ROW_INNER_SPACING,
  SHELL_MAIN_CHROME_PADDING_PX,
  TABLE_PAGE_CONTAINER_HEIGHT,
  VIEWPORT_2K_MIN_MEDIA,
  VIEWPORT_2K_MIN_WIDTH_MATCH,
  VIEWPORT_2K_MIN_WIDTH_PX,
  SHELL_SIDEBAR_WIDTH_2K_PX,
  SHELL_NAV_ROW_HEIGHT_2K_PX,
  VIEWPORT_4K_MIN_MEDIA,
  VIEWPORT_4K_MIN_WIDTH_MATCH,
  VIEWPORT_4K_MIN_WIDTH_PX,
  SHELL_SIDEBAR_WIDTH_4K_PX,
  SHELL_NAV_ROW_HEIGHT_4K_PX,
} from "./layout";
